/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.11.3.0 (NJsonSchema v10.4.4.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const COURSE_API_BASE_URL = new InjectionToken<string>('COURSE_API_BASE_URL');

@Injectable()
export class AchievementsAppService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(COURSE_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param activityId (optional) 
     * @param userId (optional) 
     * @return Success
     */
    getActivityRewards(activityId: string | undefined, userId: number | undefined): Observable<ActivityRewardsDto> {
        let url_ = this.baseUrl + "/api/workbook/course/achievements/get-activity-rewards?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivityRewards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivityRewards(<any>response_);
                } catch (e) {
                    return <Observable<ActivityRewardsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivityRewardsDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetActivityRewards(response: HttpResponseBase): Observable<ActivityRewardsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityRewardsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityRewardsDto>(<any>null);
    }

    /**
     * @param studentId (optional) 
     * @return Success
     */
    getAchievements(studentId: number | undefined): Observable<AchievementInfo[]> {
        let url_ = this.baseUrl + "/api/workbook/course/achievements/get-achievements?";
        if (studentId === null)
            throw new Error("The parameter 'studentId' cannot be null.");
        else if (studentId !== undefined)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAchievements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAchievements(<any>response_);
                } catch (e) {
                    return <Observable<AchievementInfo[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AchievementInfo[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAchievements(response: HttpResponseBase): Observable<AchievementInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AchievementInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AchievementInfo[]>(<any>null);
    }
}

@Injectable()
export class ActivityAppService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(COURSE_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param studentId (optional) 
     * @param courseId (optional) 
     * @param subjectId (optional) 
     * @return Success
     */
    getRecentActivities(studentId: number | undefined, courseId: number | undefined, subjectId: number | undefined): Observable<GetActivitiesResponse> {
        let url_ = this.baseUrl + "/api/workbook/course/activity/get-recent-activities?";
        if (studentId === null)
            throw new Error("The parameter 'studentId' cannot be null.");
        else if (studentId !== undefined)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "courseId=" + encodeURIComponent("" + courseId) + "&";
        if (subjectId === null)
            throw new Error("The parameter 'subjectId' cannot be null.");
        else if (subjectId !== undefined)
            url_ += "subjectId=" + encodeURIComponent("" + subjectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentActivities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentActivities(<any>response_);
                } catch (e) {
                    return <Observable<GetActivitiesResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetActivitiesResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetRecentActivities(response: HttpResponseBase): Observable<GetActivitiesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetActivitiesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetActivitiesResponse>(<any>null);
    }

    /**
     * @param courseId (optional) 
     * @return Success
     */
    getCourseSegments(courseId: number | undefined): Observable<GetCourseSegmentsResult> {
        let url_ = this.baseUrl + "/api/workbook/course/activity/get-course-segments?";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "courseId=" + encodeURIComponent("" + courseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCourseSegments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCourseSegments(<any>response_);
                } catch (e) {
                    return <Observable<GetCourseSegmentsResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCourseSegmentsResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetCourseSegments(response: HttpResponseBase): Observable<GetCourseSegmentsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCourseSegmentsResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCourseSegmentsResult>(<any>null);
    }

    /**
     * @param studentId (optional) 
     * @param activityId (optional) 
     * @return Success
     */
    getActivity(studentId: number | undefined, activityId: string | undefined): Observable<StudentActivityDto> {
        let url_ = this.baseUrl + "/api/workbook/course/activity/get-activity?";
        if (studentId === null)
            throw new Error("The parameter 'studentId' cannot be null.");
        else if (studentId !== undefined)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivity(<any>response_);
                } catch (e) {
                    return <Observable<StudentActivityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StudentActivityDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetActivity(response: HttpResponseBase): Observable<StudentActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StudentActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StudentActivityDto>(<any>null);
    }

    /**
     * @return Success
     */
    getNinetiesClub(): Observable<NinetiesClubMemberDto[]> {
        let url_ = this.baseUrl + "/api/workbook/course/activity/get-nineties-club";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNinetiesClub(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNinetiesClub(<any>response_);
                } catch (e) {
                    return <Observable<NinetiesClubMemberDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NinetiesClubMemberDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetNinetiesClub(response: HttpResponseBase): Observable<NinetiesClubMemberDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(NinetiesClubMemberDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NinetiesClubMemberDto[]>(<any>null);
    }

    /**
     * @param courseId (optional) 
     * @return Success
     */
    getNinetiesClubSections(courseId: number | undefined): Observable<ClubSectionDto[]> {
        let url_ = this.baseUrl + "/api/workbook/course/activity/get-nineties-club-sections?";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "courseId=" + encodeURIComponent("" + courseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNinetiesClubSections(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNinetiesClubSections(<any>response_);
                } catch (e) {
                    return <Observable<ClubSectionDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ClubSectionDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetNinetiesClubSections(response: HttpResponseBase): Observable<ClubSectionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ClubSectionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClubSectionDto[]>(<any>null);
    }

    /**
     * @param studentId (optional) 
     * @param courseId (optional) 
     * @return Success
     */
    getSubjectProgress(studentId: number | undefined, courseId: number | undefined): Observable<SubjectProgressDto[]> {
        let url_ = this.baseUrl + "/api/workbook/course/activity/get-subject-progress?";
        if (studentId === null)
            throw new Error("The parameter 'studentId' cannot be null.");
        else if (studentId !== undefined)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "courseId=" + encodeURIComponent("" + courseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubjectProgress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubjectProgress(<any>response_);
                } catch (e) {
                    return <Observable<SubjectProgressDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubjectProgressDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSubjectProgress(response: HttpResponseBase): Observable<SubjectProgressDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SubjectProgressDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubjectProgressDto[]>(<any>null);
    }

    /**
     * @param studentId (optional) 
     * @param subjectId (optional) 
     * @return Success
     */
    getTopicProgress(studentId: number | undefined, subjectId: number | undefined): Observable<TopicProgressDto[]> {
        let url_ = this.baseUrl + "/api/workbook/course/activity/get-topic-progress?";
        if (studentId === null)
            throw new Error("The parameter 'studentId' cannot be null.");
        else if (studentId !== undefined)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        if (subjectId === null)
            throw new Error("The parameter 'subjectId' cannot be null.");
        else if (subjectId !== undefined)
            url_ += "subjectId=" + encodeURIComponent("" + subjectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTopicProgress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopicProgress(<any>response_);
                } catch (e) {
                    return <Observable<TopicProgressDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TopicProgressDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTopicProgress(response: HttpResponseBase): Observable<TopicProgressDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TopicProgressDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TopicProgressDto[]>(<any>null);
    }
}

@Injectable()
export class ClassAppService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(COURSE_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param studentId (optional) 
     * @param courseId (optional) 
     * @return Success
     */
    getStudentClasses(studentId: number | undefined, courseId: number | undefined): Observable<ClassDto[]> {
        let url_ = this.baseUrl + "/api/workbook/course/class/get-student-classes?";
        if (studentId === null)
            throw new Error("The parameter 'studentId' cannot be null.");
        else if (studentId !== undefined)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "courseId=" + encodeURIComponent("" + courseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStudentClasses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStudentClasses(<any>response_);
                } catch (e) {
                    return <Observable<ClassDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ClassDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetStudentClasses(response: HttpResponseBase): Observable<ClassDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ClassDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClassDto[]>(<any>null);
    }

    /**
     * @param studentId (optional) 
     * @param classId (optional) 
     * @return Success
     */
    attendClass(studentId: number | undefined, classId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/workbook/course/class/attend-class?";
        if (studentId === null)
            throw new Error("The parameter 'studentId' cannot be null.");
        else if (studentId !== undefined)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        if (classId === null)
            throw new Error("The parameter 'classId' cannot be null.");
        else if (classId !== undefined)
            url_ += "classId=" + encodeURIComponent("" + classId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAttendClass(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAttendClass(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processAttendClass(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param activityId (optional) 
     * @return Success
     */
    getClassRecording(activityId: string | undefined): Observable<ClassRecordingDto> {
        let url_ = this.baseUrl + "/api/workbook/course/class/get-class-recording?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClassRecording(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClassRecording(<any>response_);
                } catch (e) {
                    return <Observable<ClassRecordingDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ClassRecordingDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetClassRecording(response: HttpResponseBase): Observable<ClassRecordingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClassRecordingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClassRecordingDto>(<any>null);
    }
}

export class AchievementInfo implements IAchievementInfo {
    studentId: number;
    courseId: number;
    itemId: string | undefined;
    itemType: string | undefined;
    item: string | undefined;
    rewardType: string | undefined;
    rewardId: number;
    title: string | undefined;
    message: string | undefined;
    imageId: number;
    imageUrl: string | undefined;
    achievedAt: moment.Moment | undefined;

    constructor(data?: IAchievementInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studentId = _data["studentId"];
            this.courseId = _data["courseId"];
            this.itemId = _data["itemId"];
            this.itemType = _data["itemType"];
            this.item = _data["item"];
            this.rewardType = _data["rewardType"];
            this.rewardId = _data["rewardId"];
            this.title = _data["title"];
            this.message = _data["message"];
            this.imageId = _data["imageId"];
            this.imageUrl = _data["imageUrl"];
            this.achievedAt = _data["achievedAt"] ? moment(_data["achievedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AchievementInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AchievementInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentId"] = this.studentId;
        data["courseId"] = this.courseId;
        data["itemId"] = this.itemId;
        data["itemType"] = this.itemType;
        data["item"] = this.item;
        data["rewardType"] = this.rewardType;
        data["rewardId"] = this.rewardId;
        data["title"] = this.title;
        data["message"] = this.message;
        data["imageId"] = this.imageId;
        data["imageUrl"] = this.imageUrl;
        data["achievedAt"] = this.achievedAt ? this.achievedAt.toISOString() : <any>undefined;
        return data; 
    }

    clone(): AchievementInfo {
        const json = this.toJSON();
        let result = new AchievementInfo();
        result.init(json);
        return result;
    }
}

export interface IAchievementInfo {
    studentId: number;
    courseId: number;
    itemId: string | undefined;
    itemType: string | undefined;
    item: string | undefined;
    rewardType: string | undefined;
    rewardId: number;
    title: string | undefined;
    message: string | undefined;
    imageId: number;
    imageUrl: string | undefined;
    achievedAt: moment.Moment | undefined;
}

export class ActivityRewardsDto implements IActivityRewardsDto {
    userId: number;
    activityId: string | undefined;
    actionType: string | undefined;
    points: number | undefined;
    achievements: AchievementInfo[] | undefined;

    constructor(data?: IActivityRewardsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.activityId = _data["activityId"];
            this.actionType = _data["actionType"];
            this.points = _data["points"];
            if (Array.isArray(_data["achievements"])) {
                this.achievements = [] as any;
                for (let item of _data["achievements"])
                    this.achievements.push(AchievementInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActivityRewardsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityRewardsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["activityId"] = this.activityId;
        data["actionType"] = this.actionType;
        data["points"] = this.points;
        if (Array.isArray(this.achievements)) {
            data["achievements"] = [];
            for (let item of this.achievements)
                data["achievements"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ActivityRewardsDto {
        const json = this.toJSON();
        let result = new ActivityRewardsDto();
        result.init(json);
        return result;
    }
}

export interface IActivityRewardsDto {
    userId: number;
    activityId: string | undefined;
    actionType: string | undefined;
    points: number | undefined;
    achievements: AchievementInfo[] | undefined;
}

export enum PublishStatusKind {
    New = <any>"New",
    Draft = <any>"Draft",
    Review = <any>"Review",
    Published = <any>"Published",
    Archived = <any>"Archived",
}

export enum ActivityStatusKind {
    Upcoming = <any>"Upcoming",
    Due = <any>"Due",
    InProgress = <any>"InProgress",
    Completed = <any>"Completed",
    Closed = <any>"Closed",
    Submitted = <any>"Submitted",
}

export class StudentActivityDto implements IStudentActivityDto {
    courseId: number;
    activityId: string;
    activityType: string | undefined;
    title: string | undefined;
    subject: string | undefined;
    subjectId: number;
    topic: string | undefined;
    topicId: number;
    previewImageId: number;
    previewImageUrl: string | undefined;
    releaseDate: moment.Moment | undefined;
    dueDate: moment.Moment | undefined;
    startTime: moment.Moment | undefined;
    completedTime: moment.Moment | undefined;
    publishingStatus: PublishStatusKind;
    itemIndex: number;
    activityStatus: ActivityStatusKind;
    status: string | undefined;
    studentId: number;
    isAvailable: boolean;
    hasAccess: boolean;
    score: number;
    readonly isCompleted: boolean;
    assignmentType: string | undefined;
    assignmentTypeId: number;
    courseSegmentId: number;
    sequenceNumber: number;
    isGraded: boolean;
    isAssignment: boolean;
    segmentId: number;
    subjectSequenceNumber: number;
    indexNumber: number;
    readonly starRating: number;
    id: string;

    constructor(data?: IStudentActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseId = _data["courseId"];
            this.activityId = _data["activityId"];
            this.activityType = _data["activityType"];
            this.title = _data["title"];
            this.subject = _data["subject"];
            this.subjectId = _data["subjectId"];
            this.topic = _data["topic"];
            this.topicId = _data["topicId"];
            this.previewImageId = _data["previewImageId"];
            this.previewImageUrl = _data["previewImageUrl"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.completedTime = _data["completedTime"] ? moment(_data["completedTime"].toString()) : <any>undefined;
            this.publishingStatus = _data["publishingStatus"];
            this.itemIndex = _data["itemIndex"];
            this.activityStatus = _data["activityStatus"];
            this.status = _data["status"];
            this.studentId = _data["studentId"];
            this.isAvailable = _data["isAvailable"];
            this.hasAccess = _data["hasAccess"];
            this.score = _data["score"];
            (<any>this).isCompleted = _data["isCompleted"];
            this.assignmentType = _data["assignmentType"];
            this.assignmentTypeId = _data["assignmentTypeId"];
            this.courseSegmentId = _data["courseSegmentId"];
            this.sequenceNumber = _data["sequenceNumber"];
            this.isGraded = _data["isGraded"];
            this.isAssignment = _data["isAssignment"];
            this.segmentId = _data["segmentId"];
            this.subjectSequenceNumber = _data["subjectSequenceNumber"];
            this.indexNumber = _data["indexNumber"];
            (<any>this).starRating = _data["starRating"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): StudentActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudentActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId;
        data["activityId"] = this.activityId;
        data["activityType"] = this.activityType;
        data["title"] = this.title;
        data["subject"] = this.subject;
        data["subjectId"] = this.subjectId;
        data["topic"] = this.topic;
        data["topicId"] = this.topicId;
        data["previewImageId"] = this.previewImageId;
        data["previewImageUrl"] = this.previewImageUrl;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["completedTime"] = this.completedTime ? this.completedTime.toISOString() : <any>undefined;
        data["publishingStatus"] = this.publishingStatus;
        data["itemIndex"] = this.itemIndex;
        data["activityStatus"] = this.activityStatus;
        data["status"] = this.status;
        data["studentId"] = this.studentId;
        data["isAvailable"] = this.isAvailable;
        data["hasAccess"] = this.hasAccess;
        data["score"] = this.score;
        data["isCompleted"] = this.isCompleted;
        data["assignmentType"] = this.assignmentType;
        data["assignmentTypeId"] = this.assignmentTypeId;
        data["courseSegmentId"] = this.courseSegmentId;
        data["sequenceNumber"] = this.sequenceNumber;
        data["isGraded"] = this.isGraded;
        data["isAssignment"] = this.isAssignment;
        data["segmentId"] = this.segmentId;
        data["subjectSequenceNumber"] = this.subjectSequenceNumber;
        data["indexNumber"] = this.indexNumber;
        data["starRating"] = this.starRating;
        data["id"] = this.id;
        return data; 
    }

    clone(): StudentActivityDto {
        const json = this.toJSON();
        let result = new StudentActivityDto();
        result.init(json);
        return result;
    }
}

export interface IStudentActivityDto {
    courseId: number;
    activityId: string;
    activityType: string | undefined;
    title: string | undefined;
    subject: string | undefined;
    subjectId: number;
    topic: string | undefined;
    topicId: number;
    previewImageId: number;
    previewImageUrl: string | undefined;
    releaseDate: moment.Moment | undefined;
    dueDate: moment.Moment | undefined;
    startTime: moment.Moment | undefined;
    completedTime: moment.Moment | undefined;
    publishingStatus: PublishStatusKind;
    itemIndex: number;
    activityStatus: ActivityStatusKind;
    status: string | undefined;
    studentId: number;
    isAvailable: boolean;
    hasAccess: boolean;
    score: number;
    isCompleted: boolean;
    assignmentType: string | undefined;
    assignmentTypeId: number;
    courseSegmentId: number;
    sequenceNumber: number;
    isGraded: boolean;
    isAssignment: boolean;
    segmentId: number;
    subjectSequenceNumber: number;
    indexNumber: number;
    starRating: number;
    id: string;
}

export class GetActivitiesResponse implements IGetActivitiesResponse {
    assignments: StudentActivityDto[] | undefined;

    constructor(data?: IGetActivitiesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assignments"])) {
                this.assignments = [] as any;
                for (let item of _data["assignments"])
                    this.assignments.push(StudentActivityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetActivitiesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivitiesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assignments)) {
            data["assignments"] = [];
            for (let item of this.assignments)
                data["assignments"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetActivitiesResponse {
        const json = this.toJSON();
        let result = new GetActivitiesResponse();
        result.init(json);
        return result;
    }
}

export interface IGetActivitiesResponse {
    assignments: StudentActivityDto[] | undefined;
}

export class CourseSegmentDto implements ICourseSegmentDto {
    courseId: number;
    title: string | undefined;
    sectionId: number;
    segmentNumber: number;
    segmentOrder: number;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    publishStatus: PublishStatusKind;
    activities: StudentActivityDto[] | undefined;
    id: number;

    constructor(data?: ICourseSegmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseId = _data["courseId"];
            this.title = _data["title"];
            this.sectionId = _data["sectionId"];
            this.segmentNumber = _data["segmentNumber"];
            this.segmentOrder = _data["segmentOrder"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.publishStatus = _data["publishStatus"];
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities.push(StudentActivityDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CourseSegmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseSegmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId;
        data["title"] = this.title;
        data["sectionId"] = this.sectionId;
        data["segmentNumber"] = this.segmentNumber;
        data["segmentOrder"] = this.segmentOrder;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["publishStatus"] = this.publishStatus;
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): CourseSegmentDto {
        const json = this.toJSON();
        let result = new CourseSegmentDto();
        result.init(json);
        return result;
    }
}

export interface ICourseSegmentDto {
    courseId: number;
    title: string | undefined;
    sectionId: number;
    segmentNumber: number;
    segmentOrder: number;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    publishStatus: PublishStatusKind;
    activities: StudentActivityDto[] | undefined;
    id: number;
}

export class CourseSectionDto implements ICourseSectionDto {
    courseId: number;
    sectionNumber: number;
    title: string | undefined;
    id: number;

    constructor(data?: ICourseSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseId = _data["courseId"];
            this.sectionNumber = _data["sectionNumber"];
            this.title = _data["title"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CourseSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourseSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId;
        data["sectionNumber"] = this.sectionNumber;
        data["title"] = this.title;
        data["id"] = this.id;
        return data; 
    }

    clone(): CourseSectionDto {
        const json = this.toJSON();
        let result = new CourseSectionDto();
        result.init(json);
        return result;
    }
}

export interface ICourseSectionDto {
    courseId: number;
    sectionNumber: number;
    title: string | undefined;
    id: number;
}

export class GetCourseSegmentsResult implements IGetCourseSegmentsResult {
    segments: CourseSegmentDto[] | undefined;
    sections: CourseSectionDto[] | undefined;

    constructor(data?: IGetCourseSegmentsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["segments"])) {
                this.segments = [] as any;
                for (let item of _data["segments"])
                    this.segments.push(CourseSegmentDto.fromJS(item));
            }
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections.push(CourseSectionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCourseSegmentsResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCourseSegmentsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.segments)) {
            data["segments"] = [];
            for (let item of this.segments)
                data["segments"].push(item.toJSON());
        }
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetCourseSegmentsResult {
        const json = this.toJSON();
        let result = new GetCourseSegmentsResult();
        result.init(json);
        return result;
    }
}

export interface IGetCourseSegmentsResult {
    segments: CourseSegmentDto[] | undefined;
    sections: CourseSectionDto[] | undefined;
}

export class NinetiesClubMemberDto implements INinetiesClubMemberDto {
    courseId: number;
    studentId: number;
    studentNumber: string | undefined;
    examTitle: string | undefined;
    grade: number;
    fullName: string | undefined;
    sectionId: number;
    avatarImageId: number;
    avatarImageUrl: string | undefined;

    constructor(data?: INinetiesClubMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseId = _data["courseId"];
            this.studentId = _data["studentId"];
            this.studentNumber = _data["studentNumber"];
            this.examTitle = _data["examTitle"];
            this.grade = _data["grade"];
            this.fullName = _data["fullName"];
            this.sectionId = _data["sectionId"];
            this.avatarImageId = _data["avatarImageId"];
            this.avatarImageUrl = _data["avatarImageUrl"];
        }
    }

    static fromJS(data: any): NinetiesClubMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new NinetiesClubMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId;
        data["studentId"] = this.studentId;
        data["studentNumber"] = this.studentNumber;
        data["examTitle"] = this.examTitle;
        data["grade"] = this.grade;
        data["fullName"] = this.fullName;
        data["sectionId"] = this.sectionId;
        data["avatarImageId"] = this.avatarImageId;
        data["avatarImageUrl"] = this.avatarImageUrl;
        return data; 
    }

    clone(): NinetiesClubMemberDto {
        const json = this.toJSON();
        let result = new NinetiesClubMemberDto();
        result.init(json);
        return result;
    }
}

export interface INinetiesClubMemberDto {
    courseId: number;
    studentId: number;
    studentNumber: string | undefined;
    examTitle: string | undefined;
    grade: number;
    fullName: string | undefined;
    sectionId: number;
    avatarImageId: number;
    avatarImageUrl: string | undefined;
}

export class ClubSectionDto implements IClubSectionDto {
    name: string | undefined;
    sectionDate: moment.Moment;
    members: NinetiesClubMemberDto[] | undefined;
    id: number;

    constructor(data?: IClubSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.sectionDate = _data["sectionDate"] ? moment(_data["sectionDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members.push(NinetiesClubMemberDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ClubSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClubSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sectionDate"] = this.sectionDate ? this.sectionDate.toISOString() : <any>undefined;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): ClubSectionDto {
        const json = this.toJSON();
        let result = new ClubSectionDto();
        result.init(json);
        return result;
    }
}

export interface IClubSectionDto {
    name: string | undefined;
    sectionDate: moment.Moment;
    members: NinetiesClubMemberDto[] | undefined;
    id: number;
}

export class SubjectProgressDto implements ISubjectProgressDto {
    id: number;
    name: string | undefined;
    readonly key: string | undefined;
    completedAssignments: number;
    totalAssignments: number;
    completedPercent: number;
    averageScore: number;

    constructor(data?: ISubjectProgressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            (<any>this).key = _data["key"];
            this.completedAssignments = _data["completedAssignments"];
            this.totalAssignments = _data["totalAssignments"];
            this.completedPercent = _data["completedPercent"];
            this.averageScore = _data["averageScore"];
        }
    }

    static fromJS(data: any): SubjectProgressDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubjectProgressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["key"] = this.key;
        data["completedAssignments"] = this.completedAssignments;
        data["totalAssignments"] = this.totalAssignments;
        data["completedPercent"] = this.completedPercent;
        data["averageScore"] = this.averageScore;
        return data; 
    }

    clone(): SubjectProgressDto {
        const json = this.toJSON();
        let result = new SubjectProgressDto();
        result.init(json);
        return result;
    }
}

export interface ISubjectProgressDto {
    id: number;
    name: string | undefined;
    key: string | undefined;
    completedAssignments: number;
    totalAssignments: number;
    completedPercent: number;
    averageScore: number;
}

export class TopicProgressDto implements ITopicProgressDto {
    id: number;
    title: string | undefined;
    indexNumber: number;
    subject: string | undefined;
    subjectId: number;
    completedActivities: number;
    totalActivities: number;
    readonly progressPercent: number;
    studentGrade: number;
    rating: number;
    activities: StudentActivityDto[] | undefined;

    constructor(data?: ITopicProgressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.indexNumber = _data["indexNumber"];
            this.subject = _data["subject"];
            this.subjectId = _data["subjectId"];
            this.completedActivities = _data["completedActivities"];
            this.totalActivities = _data["totalActivities"];
            (<any>this).progressPercent = _data["progressPercent"];
            this.studentGrade = _data["studentGrade"];
            this.rating = _data["rating"];
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities.push(StudentActivityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TopicProgressDto {
        data = typeof data === 'object' ? data : {};
        let result = new TopicProgressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["indexNumber"] = this.indexNumber;
        data["subject"] = this.subject;
        data["subjectId"] = this.subjectId;
        data["completedActivities"] = this.completedActivities;
        data["totalActivities"] = this.totalActivities;
        data["progressPercent"] = this.progressPercent;
        data["studentGrade"] = this.studentGrade;
        data["rating"] = this.rating;
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item.toJSON());
        }
        return data; 
    }

    clone(): TopicProgressDto {
        const json = this.toJSON();
        let result = new TopicProgressDto();
        result.init(json);
        return result;
    }
}

export interface ITopicProgressDto {
    id: number;
    title: string | undefined;
    indexNumber: number;
    subject: string | undefined;
    subjectId: number;
    completedActivities: number;
    totalActivities: number;
    progressPercent: number;
    studentGrade: number;
    rating: number;
    activities: StudentActivityDto[] | undefined;
}

export enum MeetingStatusKind {
    Scheduled = <any>"Scheduled",
    Available = <any>"Available",
    InProgress = <any>"InProgress",
    Completed = <any>"Completed",
}

export class ClassDto implements IClassDto {
    liveClassId: number;
    title: string | undefined;
    description: string | undefined;
    startTime: moment.Moment;
    endTime: moment.Moment;
    status: MeetingStatusKind;
    meetingType: string | undefined;
    meetingLink: string | undefined;
    readonly time: string | undefined;
    id: number;

    constructor(data?: IClassDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.liveClassId = _data["liveClassId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.meetingType = _data["meetingType"];
            this.meetingLink = _data["meetingLink"];
            (<any>this).time = _data["time"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ClassDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClassDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["liveClassId"] = this.liveClassId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["meetingType"] = this.meetingType;
        data["meetingLink"] = this.meetingLink;
        data["time"] = this.time;
        data["id"] = this.id;
        return data; 
    }

    clone(): ClassDto {
        const json = this.toJSON();
        let result = new ClassDto();
        result.init(json);
        return result;
    }
}

export interface IClassDto {
    liveClassId: number;
    title: string | undefined;
    description: string | undefined;
    startTime: moment.Moment;
    endTime: moment.Moment;
    status: MeetingStatusKind;
    meetingType: string | undefined;
    meetingLink: string | undefined;
    time: string | undefined;
    id: number;
}

export class ClassRecordingDto implements IClassRecordingDto {
    title: string | undefined;
    description: string | undefined;
    courseId: number;
    subjectId: number | undefined;
    subject: string | undefined;
    activityId: string;
    url: string | undefined;
    videoId: string | undefined;

    constructor(data?: IClassRecordingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.courseId = _data["courseId"];
            this.subjectId = _data["subjectId"];
            this.subject = _data["subject"];
            this.activityId = _data["activityId"];
            this.url = _data["url"];
            this.videoId = _data["videoId"];
        }
    }

    static fromJS(data: any): ClassRecordingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClassRecordingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["courseId"] = this.courseId;
        data["subjectId"] = this.subjectId;
        data["subject"] = this.subject;
        data["activityId"] = this.activityId;
        data["url"] = this.url;
        data["videoId"] = this.videoId;
        return data; 
    }

    clone(): ClassRecordingDto {
        const json = this.toJSON();
        let result = new ClassRecordingDto();
        result.init(json);
        return result;
    }
}

export interface IClassRecordingDto {
    title: string | undefined;
    description: string | undefined;
    courseId: number;
    subjectId: number | undefined;
    subject: string | undefined;
    activityId: string;
    url: string | undefined;
    videoId: string | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}